import { useQuery } from '@tanstack/react-query';
import type { AppCurrency, InsightsSummary } from '@financial/shared';
import { api } from '../../lib/api';
import { currentCurrency } from '../../lib/format';

export function useInsights(month?: string, currency?: AppCurrency) {
  const activeCurrency = currency ?? currentCurrency();
  return useQuery({
    queryKey: ['insights', month ?? 'current', activeCurrency],
    queryFn: async (): Promise<InsightsSummary> => {
      const res = await api.get<InsightsSummary>('/insights/summary', {
        params: { ...(month ? { month } : {}), currency: activeCurrency },
      });
      return res.data;
    },
  });
}
